import React, { useEffect, useState } from "react";
import '../styles/LabResults.css';
import PageHeader from "../components/PageHeader";
import InputText from "../components/inputs/InputText";
import { Empty, Spin } from "antd";
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { Api } from "../api/Api";
import { showToast } from "../helpers/UIHelper";
import { useAuth } from "../context/AuthContext";
import LabResultItem from "../components/LabResultItem";
import { Modal } from "antd";
import refresh from '../assets/images/sync-alt-solid.svg';
import { Button, Input } from "antd";


const LabResults = () => {
    const [billNumber, setBillNumber] = useState();
    const [password, setPassword] = useState();
    const [searching, setSearching] = useState(false);
    const [fromDate, setFromDate] = useState(dayjs().subtract(7, 'day'));
    const [toDate, setToDate] = useState(dayjs());
    const [labresults, setLabresults] = useState([]);
    const [isEmpty, setIsEmpty] = useState(false);
    const Auth = useAuth();
    const [isdownloadingallpdfs, setIsDownloadAllpdfs] = useState(false);
    const [captcha, setCaptcha] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [captchacode, setCaptchacode] = useState();
    const [captchaKey, setCaptchaKey] = useState();
    const noAuth = window.location.href.includes('/user-access');

    useEffect(()=>{
        if(captchacode){
            console.log("cpachaa updated code" , captchacode);
        }
    }, [captchacode]);

    const formatDate = (date) => {
        return dayjs(date).format('DD/MM/YYYY');
    }
    const search = async() =>{
        if (!billNumber) {
            showToast('error', 'Bill number is mandatory.');
            return;
        }
        if (!password) {
            showToast('error', 'Password is mandatory.');
            return;
        }
        setSearching(true);
        setLabresults([]);
        if(!Auth.userIsFullAuthenticated() && !captchacode && noAuth){
            setShowModal(true);
            loadCaptcha();
            return;
        }
        var payload = null;
        if(captchacode){
            setIsSubmitting(true);
            payload = {
                fromdate: formatDate(fromDate), todate: formatDate(toDate),
                //mrno: Auth.getUser().data.patients[0].mrnNo,
                resultstatus: '302', search: '%',
                billno: billNumber, password: password,
                captchacode: captchacode,captcha_key: captchaKey
            }
        }else{
            payload = {
                fromdate: formatDate(fromDate), todate: formatDate(toDate),
                //mrno: Auth.getUser().data.patients[0].mrnNo,
                resultstatus: '302', search: '%',
                billno: billNumber, password: password
            }
        }
       await Api.post('/api/mobileLabResultsListMrno', payload).then((res) => {
            if (res.status === 200) {
                if (res.data.lab_result_list.length > 0) {
                    if (res.data.lab_result_list[0].service_name) {
                        setIsEmpty(false);
                        setLabresults(res.data.lab_result_list);
                    }
                } else {
                    setLabresults([]);
                    setIsEmpty(true);
                }
              setCaptchacode(null);
              setShowModal(false);
              setIsSubmitting(false);
              setSearching(false);
            } else {
                if(!Auth.userIsFullAuthenticated() && !noAuth){
                    loadCaptcha();
                    setCaptchacode(null);
                }
                showToast('error', 'Error occured while fetching lab results');
            }
        }).catch((e) => {
            if(!Auth.userIsFullAuthenticated() && noAuth){
                showToast('error', "Incorrect captcha entered")
                loadCaptcha();
                setCaptchacode(null);
                setIsSubmitting(false);
            }
             }).finally(() => {
            setSearching(false);setCaptchacode(null);setIsSubmitting(false); })
    }
    const validateDate = (type, date) => {
        if (type === 'from') {
            if (date.isAfter(toDate) && formatDate(toDate) !== formatDate(date)) {
                showToast('error', 'From date cannot be after To date');
                return;
            }
            setFromDate(date);
        }
        if (type === 'to') {
            if (date.isBefore(fromDate)) {
                showToast('error', 'To date cannot be before From date')
                return;
            }
            setToDate(date);
        }
    }

    const loadCaptcha = () => {
        Api.get(`/registration/getcaptcha?mobileNo=`).then((resp) => {
            if (resp.status === 200 && resp.data.status === 'success') {
                console.log(resp.data)
                setCaptcha(resp.data.captchaImage);
                setCaptchaKey(resp.data.captchaKey);
            } else {
                showToast('error', 'Failed to load captcha')
            }
        }).catch((e) => {
            showToast('error', 'Failed to load captcha')
        })
    }

    const getAllUrls = () => {
        //const patientId = Auth.getUser().data.patients[0].patientId ? Auth.getUser().data.patients[0].patientId : null;
        var urls = [];
        var laborderIds = null;
        for (var item of labresults) {
            if (item.resulttypeId === '640') {
                urls.push("?_reportFormat=pdf&ReportName=TemplateReportServiceCenter.rptdesign&__id=parameterPage&__masterpage=true" +
                    "&orderIds=*" + item.laborderId + "&patientId=" + (item.patientId ? item.patientId : '') + "&visitid=" + item.visitId + "&sampleId=*" + item.sampleid + "&resultId=" + item.labresultid + "&generatedBy=2&provisionallyCertified=false&intraBranchId=2")
            } else {
                if (laborderIds) {
                    laborderIds += "#" + item.laborderId
                } else {
                    laborderIds = item.laborderId;
                }
            }
        }
        urls.push("?_reportFormat=pdf&ReportFileName=selectedLabReportByOrder.rptdesign&ReportName=selectedLabReportByOrder.rptdesign&__id=parameterPage&__masterpage=true&" +
            "orderIds=*" + laborderIds + "&patientId=" + (item.patientId ? item.patientId : '') + "&generatedBy=2&invoiceId=*&onlyMicrobiology=false&provisionallyCertified=false&intraBranchId=2&labQrCodePath=&labPatInfoQrCodePath=");
        console.log("urlssssssssssssssssssssssssssss");
        console.log(urls);
        return urls;
    }

    const DownloadAllPdfs = () => {
        const today = new Date();
        const compareDate = new Date('2025-04-30');

        if (today < compareDate) {
            showToast('info', 'This feaure will be available from 30-04-2025');
            return;
        }
        setIsDownloadAllpdfs(true);
        const allurls = getAllUrls();
        Api.getAllReports('/api/mergeandgetpdf', allurls).then((resp) => {
            if (resp.status === 200) {
                const blob = new Blob([resp.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'merged.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }).catch((e) => {
            showToast('error', 'Error occured');
            console.log(e);
        }).finally(() => { setIsDownloadAllpdfs(false); })
    }


    return (
        <div className="labresult-page">
            <PageHeader title="Lab Results" />
            <div className="search-header">
                <InputText label="Bill Number" width="calc(50% - 20px)" value={billNumber} onChange={(v) => { setBillNumber(v); }} />
                <InputText label="Password" width="calc(50% - 20px)" value={password} onChange={(v) => { setPassword(v); }} />
                <div className="half-width-container">
                    <div className="label-text">Date From</div>
                    <DatePicker format="DD-MM-YYYY" onChange={(date) => { validateDate('from', date); }} value={fromDate} defaultValue={fromDate} maxDate={dayjs(new Date())} minDate={dayjs().subtract(6, 'month')} />
                </div>
                <div className="half-width-container">
                    <div className="label-text">Date To</div>
                    <DatePicker format="DD-MM-YYYY" onChange={(date) => { validateDate('to', date); }} value={toDate} defaultValue={toDate} maxDate={dayjs(new Date())} minDate={dayjs().subtract(6, 'month')} />
                </div>
            </div>
            <div className="search-btn"  onClick= { ()=>{search();}}>
                {searching ? <Spin /> :
                    'Search'
                }
            </div>
            {labresults.length > 0 ?
                <div className="download-button-container">
                    <div className="download-all-button"
                        onClick={() => { if (!isdownloadingallpdfs) { DownloadAllPdfs(); } }}>
                        {!isdownloadingallpdfs ? <><i className="las la-download" /><span>Download All</span></> : <Spin />}
                    </div>
                </div>
                : <></>}
            <div className="labresult-list-area">
                {
                    labresults.length > 0 ?
                        (
                            <div className="search-components">
                                {/* <button className="download-all-btn">
                                    Download All PDFs
                                </button> */}
                                {labresults.map((item, index) => (
                                    <LabResultItem item={item} key={index} />
                                ))}
                            </div>
                        )
                        :
                        <Empty description="No results found" />
                }
            </div>
            <Modal title="Enter Captcha" open={showModal} footer={null} closable={false} maskClosable={false} onCancel={() => { setShowModal(false); setCaptcha(''); setCaptchacode(null);}}>
            {captcha ? <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', margin: '10px' }}>
                <img src={'data:image/png;base64,' + captcha} alt="captcha" />
                <img style={{ marginLeft: '20px', width: '20px', height: '20px', cursor: 'pointer' }} src={refresh} onClick={loadCaptcha} alt="Reload" />
            </div> : <Spin></Spin>}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Input style={{ margin: '10px 10px' }} value={captchacode} onChange={(e) => { setCaptchacode(e.target.value);}} />
                <Button onClick={() => { search(); }} style={{ backgroundColor: '#5F0A10', color: 'white', margin: '10px 0' }} disabled={isSubmitting} >{isSubmitting ? <Spin></Spin> : 'Submit'}</Button>
            </div>
           </Modal>
        </div>
        // <></>
    )
}
export default LabResults;